"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcaneBarrageHandler = exports.ArcaneBarrageActorAbilityFactory = exports.ArcaneBarrageAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Target_1 = require("../../core/Target");
const Enumerable_1 = require("../../utils/Enumerable");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ArcaneBarrageAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ArcaneBarrage;
        this.__typeName = "ArcaneBarrage";
    }
}
exports.ArcaneBarrageAbilityArgs = ArcaneBarrageAbilityArgs;
let ArcaneBarrageActorAbilityFactory = class ArcaneBarrageActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ArcaneBarrage", "AllEnemies", 0);
    }
};
ArcaneBarrageActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ArcaneBarrage")
], ArcaneBarrageActorAbilityFactory);
exports.ArcaneBarrageActorAbilityFactory = ArcaneBarrageActorAbilityFactory;
let ArcaneBarrageHandler = class ArcaneBarrageHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        let nProjectiles = (0, Random_1.random)(1, Math.round(Math.max(container.getLevel(ability.invokerId) / 5, 5)));
        nProjectiles = Math.min(100, nProjectiles);
        const projectiles = Enumerable_1.Enumerable.range(0, nProjectiles)
            .map((i) => {
            return {
                creatorId: ability.invokerId,
                targetId: (0, Random_1.randomElement)(enemies),
                jitter: (0, Random_1.random)(0, 100),
                type: "ArcaneBolt",
                path: "arc"
            };
        });
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: projectiles.map(projectile => ({
                ...projectile,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", 25)
                ]
            }))
        });
    }
};
ArcaneBarrageHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ArcaneBarrage)
], ArcaneBarrageHandler);
exports.ArcaneBarrageHandler = ArcaneBarrageHandler;
